<template>
  <div class="wrap">
    <div class="title-box">
      <span class="title">审批信息</span>
    </div>
    <el-form
      ref="appFormRef"
      :model="form"
      label-position="top"
      :disabled="disabled"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="`授信金额（${productInfo?.minLoanMoney || 0}-${
              productInfo?.maxLoanMoney || ''
            }万元）`"
            prop="creditAmount"
          >
            <el-input
              :formatter="moneyFormatter"
              :parser="moneyParser"
              v-model="form.creditAmount"
              maxlength="12"
              style="width: 100%"
            >
              <template #suffix>元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="还款日" prop="repaymentDate">
            <el-input v-model.number="form.repaymentDate" @input="handleInput" style="width: 100%">
              <template #suffix>号</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="授信起始日" prop="creditBeginTime">
            <el-date-picker v-model="form.creditBeginTime" type="Date" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="授信到期日" prop="creditEndTime">
            <el-date-picker v-model="form.creditEndTime" type="Date" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="还款方式" prop="repaymentType">
            <el-select v-model="form.repaymentType" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="(item, index) in repaymentTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="其他还款方式"
            prop="otherRepaymentType"
            v-if="form.repaymentType === 5"
          >
            <el-input maxlength="30" v-model="form.otherRepaymentType" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="还款频率" prop="repaymentFrequency">
            <el-select v-model="form.repaymentFrequency" placeholder="请选择" style="width: 100%">
              <el-option
                v-for="(item, index) in rateList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`贷款期限（${productInfo?.minLoanTerm || 0}-${
              productInfo?.maxLoanTerm || ''
            }月）`"
            prop="loanDate"
          >
            <el-input
              v-model="form.loanDate"
              maxLength="3"
              style="width: 100%"
              @input="loanDateInput"
            >
              <template #suffix>月</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`年化利率（${productInfo?.minYearRate || 0}-${
              productInfo?.maxYearRate || ''
            }%）`"
            prop="yearRate"
          >
            <el-input v-model="form.yearRate" style="width: 100%">
              <template #suffix>%</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="罚息利率" prop="penaltyInterestRate">
            <el-input
              v-model="form.penaltyInterestRate"
              style="width: 100%"
              :disabled="comType === 102"
            >
              <template #suffix>%</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="借款人收款账号" prop="loanPayeeAccount">
            <div class="tw-flex tw-items-center tw-w-full">
              <el-select
                v-model="form.loanPayeeAccount"
                placeholder="请选择"
                style="flex: 1"
                filterable
                allow-create
                @change="changeAccount"
              >
                <el-option
                  v-for="(item, index) in bankList"
                  :key="index"
                  :label="item.label"
                  :value="item.returnCardNumber"
                />
                <template #footer>
                  <div class="card" @click="hanldeCard">添加银行卡</div>
                </template>
              </el-select>
              <span
                class="icon iconfont icon-refresh tw-ml-2 tw-cursor-pointer tw-flex-shrink-0"
                :class="{ 'rotate-loop': bankLoading }"
                style="color: #5687ff"
                @click="getBackList(true)"
              />
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="借款人开户银行" prop="loanUserBank">
            <el-input v-model="form.loanUserBank" style="width: 100%" maxLength="50" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="借款人账户名" prop="loanAccountName">
            <el-input v-model="form.loanAccountName" style="width: 100%" maxLength="50" />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="comType === 101 && businessType === 0 && isLoan">
          <el-form-item label="担保方" prop="guaranteeId">
            <el-select
              v-model="form.guaranteeId"
              :disabled="true"
              placeholder="请选择"
              style="flex: 1"
              filterable
              allow-create
            >
              <el-option
                v-for="(item, index) in guaranteeList"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="贷款用途">
            <el-input v-model="form.loanUse" show-word-limit maxlength="20" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="show">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="form.remark"
              show-word-limit
              maxlength="200"
              style="width: 100%"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script setup lang="tsx">
import { ref } from 'vue'
import { typeList, rateList } from '@/views/erp/enums'
import { cloneDeep } from '@/utils/tools'
import { isNullOrUnDef, isNullOrUndefOrEmpty } from '@/utils/is'
import { formatToDateTime } from '@/utils/date'
import { bankListget } from '@/apis/erp/loanManagement'
import { sendBindNoticeerp } from '@/apis/erp/income'
import { moneyFormatter, moneyParser } from '@/utils/money'
import { guaranteePage } from '@/apis/erp/guaranteeManage'
import { selectProxyConfig } from '@/apis/erp/productApi'
import { useAccountStore } from '@/stores/modules/account'
import { uniqBy } from 'lodash-es'
const accountStore = useAccountStore()
const isLoan = computed(() => {
  return accountStore.userInfo.isLoan
})

const props = defineProps({
  data: {
    type: Object,
    default: () => {}
  },
  disabled: {
    type: Boolean,
    default: false
  },
  show: {
    type: Boolean,
    default: true
  },
  productInfo: {
    type: Object,
    default: () => ({})
  },
  comType: Number
})

const bankList = ref<Recordable>([])
const originData = ref<{ [x: string]: any }>({})
const form = reactive<{ [x: string]: any }>({
  creditAmount: '',
  repaymentDate: '',
  creditBeginTime: '',
  creditEndTime: '',
  repaymentType: '',
  otherRepaymentType: '',
  repaymentFrequency: '',
  loanDate: '',
  yearRate: '',
  loanPayeeAccount: '',
  loanUserBank: '',
  loanAccountName: '',
  loanUse: '',
  remark: '',
  penaltyInterestRate: '',
  guaranteeId: ''
})

const businessType = ref<number | undefined>(undefined)
// 获取产品业务类型 0自营  1担保
async function getType() {
  try {
    if (props.comType === 101) {
      const res = await selectProxyConfig({ productId: props.productInfo.id })
      businessType.value = res.type
    }
  } catch (e) {
    console.log(e)
  }
}

watch(
  () => props.data,
  async () => {
    for (let key in form) {
      if (!isNullOrUnDef(props.data[key])) {
        form[key] = props.data[key]
      }
    }
    originData.value = cloneDeep(props.data)
    console.log('这里执行了多少次')
    if (loading.value) return
    loading.value = true
    if (props.data?.customerId) {
      await getBackList()
    }
    await getGuaranteeList()
    await getType()
    loading.value = false
  }
)

const loading = ref(false)
const bankLoading = ref(false)

async function getBackList(loading = false) {
  if (bankLoading.value) return
  try {
    bankLoading.value = loading

    const res = await bankListget({
      userId: props.data.customerId,
      productId: props.productInfo.id,
      customerPhone: props.data.decryptPhone,
      status: 1
    })
    bankList.value = res.map((el: Recordable) => {
      return {
        ...el,
        label: el.returnCardNumber
      }
    })

    bankList.value = uniqBy(unref(bankList) as any, 'returnCardNumber')
    const row = bankList.value.find(
      (el: Recordable) => el.returnCardNumber === form.loanPayeeAccount
    )
    if (row) {
      form.loanUserBank = row.returnCardOpenBank
      form.loanAccountName = row.returnCardAccountName
    }
  } catch (e) {
    console.log(e)
  } finally {
    // 接口太快,加个延迟展示动画
    setTimeout(() => {
      bankLoading.value = false
    }, 300)
  }
}

const repaymentTypeList = ref<LabelAndValueType[]>([])
watch(
  () => props.productInfo,
  val => {
    if (!val.repaymentType) return
    const arr = val.repaymentType.split(',').map((item: string) => +item)
    typeList.forEach(item => {
      if (arr.includes(item.value)) repaymentTypeList.value.push(item)
    })
  }
)

function hanldeCard() {
  ElMessageBox.confirm('是否发送短信通知用户绑卡？', '提示', {
    type: 'warning'
  }).then(() => {
    sendBindNoticeerp({
      phone: props.data.customerPhone,
      customerId: props.data.customerId,
      tenantId: props.productInfo?.tenantId
    }).then(() => {
      ElMessage.success('发送短信成功')
    })
  })
}

function handleInput(val: number) {
  if (!val) return
  if (val < 1) {
    form.repaymentDate = 1
    ElMessage.error('最小为1')
  }
  if (val > 31) {
    form.repaymentDate = 31
    ElMessage.error('最大为31')
  }
}

function creditValidator(_rule: any, value: string, callback: Fn) {
  let maxMoney = (props.productInfo?.maxLoanMoney || 0) * 10000
  let minMoney = (props.productInfo?.minLoanMoney || 0) * 10000
  if (isNullOrUndefOrEmpty(value)) {
    callback(new Error('请输入授信金额'))
  } else if (isNaN(Number(value))) {
    callback(new Error('请输入正确的授信金额'))
  } else if (Number(value) > maxMoney && maxMoney) {
    callback(new Error('授信金额不能大于本产品的最大授信金额'))
  } else if (Number(value) < minMoney && minMoney) {
    callback(new Error('授信金额不能小于本产品的最小授信金额'))
  } else {
    callback()
  }
}

function loanDateValidator(_rule: any, value: string, callback: Fn) {
  let max = props.productInfo?.maxLoanTerm || 0
  let min = props.productInfo?.minLoanTerm || 0
  if (isNullOrUndefOrEmpty(value)) {
    callback(new Error('请输入贷款期限'))
  } else if (isNaN(Number(value))) {
    callback(new Error('请输入正确的贷款期限'))
  } else if (Number(value) > max && max) {
    callback(new Error('贷款期限不能大于本产品的最大贷款期限'))
  } else if (Number(value) < min && min) {
    callback(new Error('贷款期限不能小于本产品的最小贷款期限'))
  } else {
    callback()
  }
}

function yearRateValidator(_rule: any, value: string, callback: Fn) {
  let max = props.productInfo?.maxYearRate || 0
  let min = props.productInfo?.minYearRate || 0
  if (isNullOrUndefOrEmpty(value)) {
    callback(new Error('请输入年化利率'))
  } else if (isNaN(Number(value))) {
    callback(new Error('请输入正确的年化利率'))
  } else if (Number(value) > max && max) {
    callback(new Error('年化利率不能大于本产品的最大年化利率'))
  } else if (Number(value) < min && min) {
    callback(new Error('年化利率不能小于本产品的最小年化利率'))
  } else {
    callback()
  }
}

function endValidator(_rule: any, value: string, callback: Fn) {
  if (isNullOrUndefOrEmpty(value)) {
    callback(new Error('请选择授信到期日'))
  } else if (form.creditBeginTime) {
    const end = new Date(value).getTime()
    const start = new Date(form.creditBeginTime).getTime()
    if (end < start) {
      callback(new Error('授信到期日不能小于授信起始日'))
    } else {
      callback()
    }
  }
}

function startValidator(_rule: any, value: string, callback: Fn) {
  if (isNullOrUndefOrEmpty(value)) {
    callback(new Error('请选择授信起始日'))
  } else if (form.creditEndTime) {
    const start = new Date(value).getTime()
    const end = new Date(form.creditEndTime).getTime()
    if (end > start) {
      appFormRef.value.clearValidate('creditEndTime')
    } else {
      appFormRef.value.validateField('creditEndTime')
    }
    callback()
  }
}

function penaltyInterestValidator(_rule: any, value: string, callback: Fn) {
  if (isNullOrUndefOrEmpty(value)) {
    callback(new Error('请输入罚息利率'))
  } else if (isNaN(Number(value))) {
    callback(new Error('请输入正确的值'))
  } else if (Number(value) > 100) {
    callback(new Error('数值不能超过100%'))
  } else if (!/^(?:\d{1}\.\d{1,6}|\d+\.\d{1,6}|\d+)$/.test(value)) {
    callback(new Error('仅支持输入六位以内小数'))
  } else {
    callback()
  }
}

const rules = ref<Recordable>({
  creditAmount: [{ required: true, validator: creditValidator, trigger: 'blur' }],
  repaymentDate: [{ required: true, message: '请输入还款日', trigger: 'blur' }],
  creditBeginTime: [{ required: true, validator: startValidator, trigger: 'change' }],
  creditEndTime: [{ required: true, validator: endValidator, trigger: 'change' }],
  repaymentType: [{ required: true, message: '请选择还款方式', trigger: ['blur', 'change'] }],
  repaymentFrequency: [{ required: true, message: '请选择还款频率', trigger: ['blur', 'change'] }],
  loanDate: [{ required: true, validator: loanDateValidator, trigger: 'blur' }],
  yearRate: [{ required: true, validator: yearRateValidator, trigger: 'blur' }],
  otherRepaymentType: [{ required: true, message: '请输入其它还款方式', trigger: 'blur' }],
  penaltyInterestRate: [{ required: true, validator: penaltyInterestValidator, trigger: 'blur' }],
  loanPayeeAccount: [{ required: true, message: '请选择借款人收款账号', trigger: ['change'] }],
  loanUserBank: [
    {
      required: true,
      message: '请输入借款开户银行',
      trigger: ['blur', 'change']
    }
  ],
  loanAccountName: [
    {
      required: true,
      message: '请输入借款人开户名',
      trigger: ['blur', 'change']
    }
  ]
  // guaranteeId: [{ required: true, message: '请选择担保方', trigger: ['blur'] }]
})

const approvalKeyName: { [x: string]: string } = {
  creditAmount: '授信金额',
  repaymentDate: '还款日',
  creditBeginTime: '授信起始日',
  creditEndTime: '授信到期日',
  repaymentType: '还款方式',
  repaymentFrequency: '还款频率',
  loanDate: '贷款期限',
  yearRate: '年化利率',
  otherRepaymentType: '其他还款方式'
  // holidaySkipFlag: '节假日顺延'
}

const appFormRef = ref()
async function getApprovalData() {
  try {
    const valid = await appFormRef.value.validate()
    if (valid) {
      let data = { ...unref(form) }
      data.creditBeginTime = formatToDateTime(data.creditBeginTime)
      data.creditEndTime = formatToDateTime(data.creditEndTime)
      return data
    }
    return false
  } catch (e) {
    return false
  }
}

function getChangeList() {
  let list: Recordable = []
  for (let key in unref(form)) {
    if (unref(form)[key] !== unref(originData)[key]) {
      let date = ['creditBeginTime', 'creditEndTime']
      list.push({
        fieldName: approvalKeyName[key],
        columnSerial: key,
        oldValue: unref(originData)[key],
        newValue: date.includes(key) ? formatToDateTime(unref(form)[key]) : unref(form)[key]
      })
    }
  }
  return list
}

function changeAccount() {
  const row = bankList.value.find((el: Recordable) => el.returnCardNumber === form.loanPayeeAccount)
  if (row) {
    form.loanUserBank = row.returnCardOpenBank
    form.loanAccountName = row.returnCardAccountName
  } else {
    if (!/^\d+$/.test(form.loanPayeeAccount)) {
      ElMessage.error('只能输入数字！')
      form.loanPayeeAccount = ''
    }
    form.loanUserBank = ''
    form.loanAccountName = ''
  }
}

function loanDateInput() {
  let value = form.loanDate.replace(/[^0-9]/g, '')
  form.loanDate = value ? Number(value) : ''
}

// 担保方
const guaranteeList = ref<Recordable[]>([])

async function getGuaranteeList() {
  const res: Recordable = await guaranteePage({
    count: false,
    model: {
      state: 'ENABLED'
    }
  })
  guaranteeList.value = res.records
  if (!res.records?.find((el: Recordable) => el.id === form.guaranteeId)) {
    form.guaranteeId = ''
  }
}

defineExpose({
  getApprovalData,
  getChangeList
})
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;

  .title {
    font-size: 14px;
    color: #333333;
    font-weight: 700;
    display: inline-block;
    border-left: 3px solid #5687ff;
    padding-left: 9px;
  }
}

.wrap {
  margin: 16px 24px;
}

.card {
  cursor: pointer;
  font-size: 14px;
  color: #5687ff;
}
</style>
